module.exports = __webpack_public_path__ + "static/media/vol.22e9f2ca.svg";